export const rubros =[
	{
		//"url":"Transparencia.html?ver=Normatividad",
	    "icono":"Normatividad.png",
	    "nombre":"1.Normatividad",
	    "formatos":[
	    	{
	    		"nombre":"Marco Normativo",
				"xlsx": "/Transparencia/xlsx/a69_f01SEMARNATH Estatal.xlsx",
				"html": "/Transparencia/htm/a69_f01SEMARNATH Estatal.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Estructura",
	    "icono":"Estructura.png",
	    "nombre":"2.Estructura",
	    "formatos":[
	    	{
	    		"nombre":"Estructura Orgánica",
				"xlsx":"/Transparencia/xlsx/a69_f02_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f02_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Organigrama",
				"xlsx":"/Transparencia/xlsx/a69_f02_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f02_bSEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Facultades",
	    "icono":"Facultades.png",
	    "nombre":"3.Facultades",
	    "formatos":[
	    	{
	    		"nombre":"Facultades",
				"xlsx":"/Transparencia/xlsx/a69_f03SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f03SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Programas_Operativos_Anuales",
	    "icono":"ProgramasOperativosAnuales.png",
	    "nombre":"4.Programas Operativos Anuales",
	    "formatos":[
	    	{
	    		"nombre":"Metas y Objetivos",
				"xlsx":"/Transparencia/xlsx/a69_f04SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f04SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Indicadores_de_Interes",
	    "icono":"IndicadoresInteres.png",
	    "nombre":"5.Indicadores de Interés",
	    "formatos":[
	    	{
	    		"nombre":"Indicadores de Interés",
				"xlsx":"/Transparencia/xlsx/a69_f05SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f05SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Matriz_de_Indicadores",
	    "icono":"MatrizIndicadores.png",
	    "nombre":"6.Matriz de Indicadores",
	    "formatos":[
	    	{
	    		"nombre":"Matriz de Indicadores",
				"xlsx":"/Transparencia/xlsx/a69_f06SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f06SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Directorio",
	    "icono":"Directorio.png",
	    "nombre":"7.Directorio",
	    "formatos":[
	    	{
	    		"nombre":"Directorio",
				"xlsx":"/Transparencia/xlsx/a69_f07SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f07SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8.%20Sueldos",
		//"url":"Transparencia.html?ver=Sueldos",
	    "icono":"Sueldos.png",
	    "nombre":"8.Sueldos",
	    "formatos":[
	    	{
	    		"nombre":"Remuneraciones",
	    		"xlsx":"https://sedeco.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f08%20SEDECO.xlsx",
	    		"html":"https://sedeco.hidalgo.gob.mx/transparencia/htm/a69_f08%20SEDECO.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Viaticos",
	    "icono":"Viaticos.png",
	    "nombre":"9.Viáticos",
	    "formatos":[
	    	{
	    		"nombre":"Viáticos",
				"xlsx":"/Transparencia/xlsx/a69_f09SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f09SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/10.%20Plazas",
		//"url":"Transparencia.html?ver=Plazas",
	    "icono":"Plazas.png",
	    "nombre":"10.Plazas",
	    "formatos":[
	    	{
	    		"nombre":"Total de Personal de Base y Confianza",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f10_aOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f10_aOM.htm",
	    	},
	    	{
	    		"nombre":"Total de las Plazas de Base y Confianza",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f10_bOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f10_bOM.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Honorarios",
	    "icono":"Honorarios.png",
	    "nombre":"11.Honorarios",
	    "formatos":[
	    	{
	    		"nombre":"Personal de Honorarios",
				"xlsx":"/Transparencia/xlsx/a69_f11SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f11SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas",
		//"url":"Transparencia.html?ver=Declaraciones_Publicas",
	    "icono":"DeclaracionesPublicas.png",
	    "nombre":"12.Declaraciones Públicas",
	    "formatos":[
	    	{
	    		"nombre":"Declaraciones Patrimoniales",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f12_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f12_SC.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad",
		//"url":"Transparencia.html?ver=Datos_de_Contacto_de_la_Unidad",
	    "icono":"DatosContactoUnidad.png",
	    "nombre":"13.Datos de contacto de la Unidad",
	    "formatos":[
	    	{
	    		"nombre":"Domicilio de la Unidad de Transparencia",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f13_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f13_SC.htm",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias",
		//"url":"Transparencia.html?ver=Convocatorias",
	    "icono":"Convocatorias.png",
	    "nombre":"14.Convocatorias",
	    "formatos":[
	    	{
	    		"nombre":"Convocatorias a Concursos para Cargos Públicos",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f14OM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f14OM.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Programas_Sociales",
	    "icono":"ProgramasSociales.png",
	    "nombre":"15.Programas Sociales",
	    "formatos":[
	    	{
	    		"nombre":"Programas de Subsidio, Estímulo y Apoyo",
				"xlsx":"/Transparencia/xlsx/a69_f15_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f15_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Padrón de beneficiarios",
				"xlsx":"/Transparencia/xlsx/a69_f15_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f15_bSEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales",
		//"url":"Transparencia.html?ver=Relaciones_Laborales",
	    "icono":"RelacionesLaborales.png",
	    "nombre":"16.Relaciones Laborales",
	    "formatos":[
	    	{
	    		"nombre":"Condiciones Generales de Trabajo",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f16_aOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f16_aOM.htm",
	    	},
	    	{
	    		"nombre":"Recursos Públicos",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f16_bOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f16_bOM.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Informacion_Curricular",
	    "icono":"InformacionCurricular.png",
	    "nombre":"17.Informacion Curricular",
	    "formatos":[
	    	{
	    		"nombre":"Información Curricular",
				"xlsx":"/Transparencia/xlsx/a69_f17SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f17SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas",
		//"url":"Transparencia.html?ver=Sanciones_Administrativas",
	    "icono":"SancionesAdministrativas.png",
	    "nombre":"18.Sanciones Administrativas",
	    "formatos":[
	    	{
	    		"nombre":"Servidores Publicos Sancionados",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f18_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f18_SC.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Servicios",
	    "icono":"Servicios.png",
	    "nombre":"19.Servicios",
	    "formatos":[
	    	{
	    		"nombre":"Servicios",
				"xlsx":"/Transparencia/xlsx/a69_f19SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f19SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Tramites",
	    "icono":"Tramites.png",
	    "nombre":"20.Trámites",
	    "formatos":[
	    	{
	    		"nombre":"Trámites",
				"xlsx":"/Transparencia/xlsx/a69_f20SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f20SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales",
		//"url":"Transparencia.html?ver=Presupuesto_e_Informes_Semestrales",
	    "icono":"PresupuestoInformesTrimestrales.png",
	    "nombre":"21.Presupuesto e Informes Trimestrales",
	    "formatos":[
	    	{
	    		"nombre":"Presupuesto Anual",
	    		"xlsx":"https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2024/Primer%20Trimestre/a69_f21_a%20SH.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f21_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Gasto trimestral",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f21_bSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f21_bSFP.htm",
	    	},
	    	{
	    		"nombre":"Cuenta Pública",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f21_cSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f21_cSFP.htm",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica",
		//"url":"Transparencia.html?ver=Deuda_Publica",
	    "icono":"DeudaPublica.png",
	    "nombre":"22.Deuda Pública",
	    "formatos":[
	    	{
	    		"nombre":"Deuda Pública",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f22SFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f22SFP.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Comunicacion_Social_y_Publicidad",
	    "icono":"ComunicacionSocialPublicidad.png",
	    "nombre":"23.Comunicación Social y Publicidad",
	    "formatos":[
	    	{
	    		"nombre":"Programa Anual de Comunicación Social",
				"xlsx":"/Transparencia/xlsx/a69_f23_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f23_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Erogación de Recursos de Comunicación Social",
				"xlsx":"/Transparencia/xlsx/a69_f23_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f23_bSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Tiempos Oficiales",
				"xlsx":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
				"html":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm",
	    	},
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas",
		//"url":"Transparencia.html?ver=Resultados_de_Auditorias",
	    "icono":"ResultadosAuditorias.png",
	    "nombre":"24.Resultados de Auditorías",
	    "formatos":[
	    	{
	    		"nombre":"Auditorías",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f24_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f24_SC.htm",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros",
		//"url":"Transparencia.html?ver=Dictamenes_de_Estados_Financieros",
	    "icono":"DictamenesFinancieros.png",
	    "nombre":"25.Dictámenes de Estados Financieros",
	    "formatos":[
	    	{
	    		"nombre":"Estados Financieros",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f25SFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f25SFP.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Asignacion_de_Recursos_Publicos_a_Personas",
	    "icono":"AsignacionRecursosPublicosPersonas.png",
	    "nombre":"26.Asignacion de Recursos Publicos a Personas",
	    "formatos":[
	    	{
	    		"nombre":"Personas a Quienes se asignó Recursos Públicos",
				"xlsx":"/Transparencia/xlsx/a69_f26SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f26SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Concesiones",
	    "icono":"Concesiones.png",
	    "nombre":"27.Concesiones",
	    "formatos":[
	    	{
	    		"nombre":"Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
				"xlsx":"/Transparencia/xlsx/a69_f27SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f27SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Licitaciones_Publicas",
	    "icono":"LicitacionesPublicas.png",
	    "nombre":"28.Licitaciones Públicas",
	    "formatos":[
	    	{
	    		"nombre":"Resultados de Procedimientos de Adjudicación Directa, Licitación Pública e Invitación Restingida",
				"xlsx":"/Transparencia/xlsx/28-LGT_Art_70_Fr_XXVIIISEMARNATH.xlsx",
				"html":"/Transparencia/htm/28-LGT_Art_70_Fr_XXVIIISEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes",
		//"url":"Transparencia.html?ver=Informes",
	    "icono":"Informes.png",
	    "nombre":"29.Informes",
	    "formatos":[
	    	{
	    		"nombre":"Informes",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f29_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f29_SC.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Estadisticas_Generales",
	    "icono":"EstadisticasGenerales.png",
	    "nombre":"30.Estadísticas Generadas",
	    "formatos":[
	    	{
	    		"nombre":"Estadísticas",
				"xlsx":"/Transparencia/xlsx/a69_f30SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f30SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros",
		//"url":"Transparencia.html?ver=Informe_de_Avances_y_Documentos_Financieros",
	    "icono":"InformeAvancesDocumentosFinancieros.png",
	    "nombre":"31.Informe de Avances y Documentos Financieros",
	    "formatos":[
	    	{
	    		"nombre":"Informe de Estados Financieros",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f31_aSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f31_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Informe Contable, Presupuestal y Programático",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f31_bSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f31_bSFP.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas",
		//"url":"Transparencia.html?ver=Padron_de_Proveedores_y_Contratistas",
	    "icono":"PadronProveedoresContratistas.png",
	    "nombre":"32.Padrón de Proveedores y Contratistas",
	    "formatos":[
	    	{
	    		"nombre":"Padrón de Proveedores y Contratistas",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f32_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f32_SC.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Convenios_con_Sectores_Social_y_Privados",
	    "icono":"ConveniosSectoresSocialPrivado.png",
	    "nombre":"33.Convenios con Sectores Social y Privados",
	    "formatos":[
	    	{
	    		"nombre":"Convenios de Coordinación y Concertación",
				"xlsx":"/Transparencia/xlsx/a69_f33SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f33SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/34.%20Inventario%20de%20Bienes",
		//"url":"Transparencia.html?ver=Inventario_de_Bienes",
	    "icono":"InventarioBienes.png",
	    "nombre":"34.Inventario de Bienes",
	    "formatos":[
	    	{
	    		"nombre":"Inventario de Bienes Muebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_aOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_aOM.htm",
	    	},
	    	{
	    		"nombre":"Alta de Bienes Muebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_bOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_bOM.htm",
	    	},
	    	{
	    		"nombre":"Bajas de Bienes Muebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_cOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_cOM.htm",
	    	},
	    	{
	    		"nombre":"Inventario de Bienes Inmuebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_dOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_dOM.htm",
	    	},
	    	{
	    		"nombre":"Alta de Bienes Inmuebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_eOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/222/a69_f34_eOM.htm",
	    	},
	    	{
	    		"nombre":"Bajas de Bienes Inmuebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_fOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_fOM.htm",
	    	},
	    	{
	    		"nombre":"Donaciones de Bienes Muebles e Inmuebles",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_gOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_gOM.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Recomendaciones_y_Atencion_en_Materia_de_Derechos_Humanos",
	    "icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
	    "nombre":"35.Recomendaciones y Atención en Materia de Derechos Humanos",
	    "formatos":[
	    	{
	    		"nombre":"Recomendaciones de Derechos Humanos Emitidas por la CNDH",
				"xlsx":"/Transparencia/xlsx/a69_f35_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f35_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Recomendaciones de Derechos Humanos Casos Especiales",
				"xlsx":"/Transparencia/xlsx/a69_f35_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f35_bSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
				"xlsx":"/Transparencia/xlsx/a69_f35_cSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f35_cSEMARNATH.htm",
	    	}
	    ]
	},
	{
		
		//"url":"Transparencia.html?ver=Resoluciones_y_Laudos_de_Juicios",
	    "icono":"ResolucionesLaudosJuicios.png",
	    "nombre":"36.Resoluciones y Laudos de Juicios",
	    "formatos":[
	    	{
	    		"nombre":"Resoluciones y Laudos",
				"xlsx":"/Transparencia/xlsx/a69_f36SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f36SEMARNATH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Mecanismos_de_Participacion_Ciudadana",
	    "icono":"MecanismosParticipacionCiudadana.png",
	    "nombre":"37.Mecanismos de Participación Ciudadana",
	    "formatos":[
	    	{
	    		"nombre":"Mecanismos de Participación Ciudadana",
				"xlsx":"/Transparencia/xlsx/a69_f37_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f37_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Resultados de los Mecanismos de Participación Ciudadana",
				"xlsx":"/Transparencia/xlsx/a69_f37_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f37_bSEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-salud.hidalgo.gob.mx/Transparencia/RubrosSsh/DetalleRubroSsh/38.%20Programas%20Ofrecidos",
	    "icono":"ProgramasOfrecidos.png",
	    "nombre":"38.Programas Ofrecidos",
	    "formatos":[
	    	{
	    		"nombre":"Programas que Ofrecen",
				"xlsx":"/Transparencia/xlsx/a69_f38_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f38_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Tramites a los Programas que Ofrecen",
				"xlsx":"/Transparencia/xlsx/a69_f38_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f38_bSEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia",
		//"url":"Transparencia.html?ver=/Actas_y_Resoluciones_del_Comite_de_Transparencia",
	    "icono":"ActasResolucionesComiteTransparencia.png",
	    "nombre":"39.Actas y Resoluciones del Comité de Transparencia",
	    "formatos":[
	    	{
	    		"nombre":"Informe de Sesiones",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39a_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39a_SC.htm",
	    	},
	    	{
	    		"nombre":"Informe de Resoluciones",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39b_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39b_SC.htm",
	    	},
	    	{
	    		"nombre":"Actas Integrantes del Comité",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39c_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39c_SC.htm",
	    	},
	    	{
	    		"nombre":"Calendario de Sesiones del comité",
	    		"xlsx":"http://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39d_SC.xlsx",
	    		"html":"http://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39d_SC.htm",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos",
		//"url":"Transparencia.html?ver=Evaluacion_y_Encuestas_a_Programas_Financiados_con_Recursos_Publicos",
	    "icono":"EvaluacionencuestasProgramas.png",
	    "nombre":"40.Evaluacion y Encuestas a Programas Financiados con Recursos Públicos",
	    "formatos":[
	    	{
	    		"nombre":"Evaluaciones",
	    		//"xlsx":"https://sedeco.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f40_a%20SEDECO.xlsx",
	    		//"html":"https://sedeco.hidalgo.gob.mx/transparencia/htm/a69_f40_a%20SEDECO.htm",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f40_aSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f40_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Encuestas",
	    		//"xlsx":"https://sedeco.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f40_b%20SEDECO.xlsx",
	    		//"html":"https://sedeco.hidalgo.gob.mx/transparencia/htm/a69_f40_b%20SEDECO.htm",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f40_bSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f40_bSFP.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Estudios_Pagados_con_Recursos_Publicos",
	    "icono":"EstudiosPagadosRecursosPublicos.png",
	    "nombre":"41.Estudios Pagados con Recursos Públicos",
	    "formatos":[
	    	{
	    		"nombre":"Estudios Pagados con Recursos Públicos",
				"xlsx":"/Transparencia/xlsx/a69_f41SEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f41SEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados",
		//"url":"Transparencia.html?ver=Listado_de_Jublidados_y_Pensionados",
	    "icono":"ListadoJubiladosPencionados.png",
	    "nombre":"42.Listado de Jubilados y Pensionados",
	    "formatos":[
	    	{
	    		"nombre":"Jubilados y Pensionados Leyenda",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f42_aOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f42_aOM.htm",
	    	},
	    	{
	    		"nombre":"Jubilados y Pensionados Listado",
	    		"xlsx":"http://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f42_bOM.xlsx",
	    		"html":"http://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f42_bOM.htm",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto",
		//"url":"Transparencia.html?ver=Ingresos_Recibidos_por_Cualquier_Concepto",
	    "icono":"IngresosRecibidosCualquierConcepto.png",
	    "nombre":"43.Ingresos Recibidos por Cualquier Concepto",
	    "formatos":[
	    	{
	    		"nombre":"Ingresos Recibidos",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f43_aSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f43_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Responsables de Recibir los Ingresos",
	    		"xlsx":"http://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f43_bSFP.xlsx",
	    		"html":"http://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f43_bSFP.htm",
	    	}
	    ]
	},
	{
		
		//"url":"Transparencia.html?ver=Donaciones_Hechas_a_Terceros",
	    "icono":"DonacionesHechasTerceros.png",
	    "nombre":"44.Donaciones Hechas a Terceros",
	    "formatos":[
	    	{
	    		"nombre":"Donaciones hechas a Terceros en Dinero y en Especie realizadas",
	    		"xlsx":"/Transparencia/xlsx/44-LGT_Art_70_Fr_XLIVSEMARNATH.xlsx",
				"html":"/Transparencia/htm/44-LGT_Art_70_Fr_XLIVSEMARNATH.htm",
	    	},

	    ]
	},
	{
		//"url":"Transparencia.html?ver=Catalogo_Documental_y_Guia_de_Archivos",
	    "icono":"CatalogoDocumentalGuiaArchivos.png",
	    "nombre":"45.Catálogo Documental y Guía de Archivos",
	    "formatos":[
	    	{
	    		"nombre":"Catálogo de Disposición y Guía de Archivos",
				"xlsx":"/Transparencia/xlsx/45a-LGT_Art_70_Fr_XLVSEMARNATH.xlsx",
				"html":"/Transparencia/htm/45a-LGT_Art_70_Fr_XLVSEMARNATH.htm",
	    	},

			{
	    		"nombre":"Índice de expedientes clasificados como reservados",
				"xlsx":"https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
				"html":"https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm",
	    	},
			{
	    		"nombre":"Cuadro general de clasificación archivística, catálogo de disposición documental",
				"xlsx":"/Transparencia/xlsx/45c-LGT_Art_70_Fr_XLVSEMARNATH.xlsx",
				"html":"/Transparencia/htm/45c-LGT_Art_70_Fr_XLVSEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos",
	    "icono":"ActasSesionesOpinionesRecomendacionesConsejosConsultivos.png",
	    "nombre":"46.Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
	    "formatos":[
	    	{
	    		"nombre":"Actas del Consejo Consultivo Ciudadano",
				"xlsx":"/Transparencia/xlsx/a69_f46aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f46aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Opiniones del Consejo Consultivo Ciudadano",
				"xlsx":"/Transparencia/xlsx/a69_f46bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f46bSEMARNATH.htm",
	    	}
	    ]
	},
	{
		"url":"https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones",
		//"url":"Transparencia.html?ver=Solicitud_de_Intervencion_de_Comunicaciones",
	    "icono":"SolicitudIntervencionComunicaciones.png",
	    "nombre":"47.Solicitud de Intervencion de Comunicaciones",
	    "formatos":[
	    	{
	    		"nombre":"Intervenciones de comunicaciones",
	    		"xlsx":"http://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f47_aPGJEH.xlsx",
	    		"html":"http://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_aPGJEH.htm",
	    	},
	    	{
	    		"nombre":"Localización Geográfica",
	    		"xlsx":"http://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f47_bPGJEH.xlsx",
	    		"html":"http://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_bPGJEH.htm",
	    	},
	    	{
	    		"nombre":"Mensaje de Solicitudes a empresas para la intervención de comunicaciones privadas",
	    		"xlsx":"http://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f47_cPGJEH.xlsx",
	    		"html":"http://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_cPGJEH.htm",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Informacion_de_Utilidad_o_Relevante",
	    "icono":"InformacionUtilidadRelevante.png",
	    "nombre":"48.Informacion de Utilidad o Relevante",
	    "formatos":[
	    	{
	    		"nombre":"Interés Público",
				"xlsx":"/Transparencia/xlsx/a69_f48_aSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f48_aSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Preguntas Frecuentes",
				"xlsx":"/Transparencia/xlsx/a69_f48_bSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f48_bSEMARNATH.htm",
	    	},
	    	{
	    		"nombre":"Transparencia Proactiva",
				"xlsx":"/Transparencia/xlsx/a69_f48_cSEMARNATH.xlsx",
				"html":"/Transparencia/htm/a69_f48_cSEMARNATH.htm",
	    	}
	    ]
	}
]